__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@freighthub/freighthub-ship";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@forto-dev/frontend-infra-auth", "3.0.139", () => (() => (__webpack_require__(56746))), 1);
			register("@forto-dev/frontend-infra-localisation", "3.0.84", () => (() => (__webpack_require__(88054))), 1);
			register("@forto-dev/frontend-infra-logger", "0.28.143", () => (() => (__webpack_require__(51358))), 1);
			register("@forto-dev/frontend-infra-logger", "0.28.184", () => (() => (__webpack_require__(33611))), 1);
			register("@forto-dev/frontend-infra-reactquery", "0.0.105", () => (() => (__webpack_require__(35510))), 1);
			register("@forto-dev/frontend-infra-unleash", "0.0.4", () => (() => (__webpack_require__(96047))), 1);
			register("@forto-dev/ui-platform-http", "4.0.0", () => (() => (__webpack_require__(63392))), 1);
			register("@freighthub/silhouette-core", "7.1.1", () => (() => (__webpack_require__(32490))), 1);
			register("mobx-react-lite", "1.5.2", () => (() => (__webpack_require__(26159))), 1);
			register("mobx-react", "4.4.3", () => (() => (__webpack_require__(6359))), 1);
			register("mobx", "3.6.2", () => (() => (__webpack_require__(22451))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(40961))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(53924))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(96540))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};